import { GridColDef } from "@mui/x-data-grid-pro";

import ItemStatus from "../../../../../../common/components/item_status";

/**
 * GenerateOrdemComprasCadastroColumnDefinition 
 */

type Props = {
  onActionEditar: (idRequisicaoProdutoServico: number | null, openState: boolean) => void;
  onActionDeletar: (idRequisicaoProdutoServico: number | null, openState: boolean) => void;
};

export const GenerateOrdemComprasCadastroColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  const computeTipoTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  const computeTipoColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeTipoDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 80,
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoTitle(params.value === 'P' ? 1 : 0)}
            color={computeTipoColor(params.value === 'P' ? 1 : 0)}
            description={computeTipoDescription(params.value === 'P' ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "numero",
      filterable: false,
      headerName: "Nº",
      minWidth: 70,
      width: 70,
      sortable: false,
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 120,
      sortable: false,
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 120,
      width: 120,
      sortable: false,
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 100,
      width: 100,
      sortable: false,
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observação",
      minWidth: 120,
      width: 120,
      sortable: false,
    },
    {
      field: "valorUnitario",
      filterable: false,
      headerName: "Valor Unitário",
      minWidth: 120,
      width: 120,
      sortable: false,
      renderCell: ({ value }) => <span>{value !== null ? `R$ ${value.toFixed(2).replaceAll('.', ',')}` : null}</span>
    },
    {
      field: "total",
      filterable: false,
      headerName: "Total",
      minWidth: 120,
      width: 120,
      sortable: false,
      renderCell: ({ value }) => <span>{value !== null ? `R$ ${value.toFixed(2).replaceAll('.', ',')}` : null}</span>
    },
  ];
}